import React, { Component } from "react";
import axios from 'axios';
import { Button } from 'react-bootstrap';
import config from '../../config/core';

const FUSER_HOST = config[process.env.NODE_ENV].FUSER_HOST;

export default class AppointmentFeedback extends Component {

    constructor(props) {
        super();
        this.state = {
            requestId: null,
            stars: 0,
            reason: "",
            submitDisabled: false,
            feedbackSubmitted: false
        };
    }

    onRatingChange = (event) => {

        const appointmentFeedbackReason = document.getElementsByClassName("appointmentFeedbackReason")[0];

        appointmentFeedbackReason.selectedIndex = 0;

        this.setState({
            stars: document.querySelectorAll(".star.appointmentFeedback.rated").length,
            reason: ""
        });

    }

    componentDidMount = () => {

        const searchParams = new URL(window.location.href).searchParams;
        const requestId = searchParams.get("requestId");

        this.setState({
            requestId: requestId
        });

        const stars = document.querySelectorAll(".star.appointmentFeedback");

        stars.forEach(function (elem) {
            elem.addEventListener("mouseover", function (_) {
                const onStar = parseInt(elem.getAttribute("data-value"));
                stars.forEach(function (ele) {
                    if (parseInt(ele.getAttribute("data-value")) <= onStar) {
                        ele.classList.remove('not-rated');
                        ele.classList.add('rated');
                    } else {
                        ele.classList.remove('rated');
                        ele.classList.add('not-rated');
                    }
                });

            });
        });

        const appointmentFeedbackReason = document.getElementsByClassName("appointmentFeedbackReason")[0];

        appointmentFeedbackReason.addEventListener('change', () => {
            this.setState({
                reason: appointmentFeedbackReason.value
            });
        })

        document.getElementById("appointment-star-rating").addEventListener('mouseup', this.onRatingChange);


    }

    handleFeedbackSubmit = async (event) => {

        event.target.disabled = true;

        this.setState({ submitDisabled: true });

        const feedback = document.getElementById("appointmentFeedbackText").value;
        const starRating = this.state.stars;

        try {
            await axios.post(
                `${FUSER_HOST}/api/v1/sal/appointmentFeedback`,
                { requestId: this.state.requestId, reason: this.state.reason, feedback: feedback, starRating: starRating }
            );
        } catch (e) {

        }

        this.setState({ feedbackSubmitted: true });
    }

    render = () => {
        if (this.state.feedbackSubmitted) {
            return (
                <h1 id="thankyou">Thank you</h1>
            )
        } else {

            let reasonsDiv;
            const starRating = this.state.stars;

            if (starRating <= 3) {
                reasonsDiv = <div className="appointmentFeebackreasons">
                    <label htmlFor="reason_123">Please tell us what can be improved:</label>

                    <select className="appointmentFeedbackReason" id="reasons_123">
                        <option value="">Please choose an option</option>
                        <option value="Not good experience while booking">Not good experience while booking</option>
                        <option value="Issues related to Medical Centre/Home technician">Issues related to Medical Centre/Home technician</option>
                        <option value="Delay in conducting tests">Delay in conducting tests</option>
                        <option value="Customer support wasn't helpful">Customer support wasn't helpful</option>
                        <option value="Others">Others</option>
                    </select>
                </div>
            } else {
                reasonsDiv = <div className="appointmentFeebackreasons">
                    <label htmlFor="reason_45">Please tell us what went great:</label>

                    <select className="appointmentFeedbackReason" id="reasons_45">
                        <option value="">Please choose an option</option>
                        <option value="Medical conducted on time/Technician  was on time">Medical conducted on time/Technician  was on time</option>
                        <option value="Staffs were polite">Staffs were polite</option>
                        <option value="Booking medicals was hassle-free">Booking medicals was hassle-free</option>
                        <option value="Awesome support from customer support">Awesome support from customer support</option>
                    </select>

                </div>
            }


            return (
                <div id="appointmentFeedback">
                    Please rate us on the booking experience
                    <div id="appointment-star-rating">
                        <span>Rating:</span>
                        <span data-value="1" className="appointmentFeedback star not-rated">&#9733;</span>
                        <span data-value="2" className="appointmentFeedback star not-rated">&#9733;</span>
                        <span data-value="3" className="appointmentFeedback star not-rated">&#9733;</span>
                        <span data-value="4" className="appointmentFeedback star not-rated">&#9733;</span>
                        <span data-value="5" className="appointmentFeedback star not-rated">&#9733;</span>
                    </div>

                    {reasonsDiv}

                    <label>
                        Please provide your valuable feedback:
                        <textarea id="appointmentFeedbackText" maxLength="300" rows="5" wrap="hard" />
                    </label>

                    <div>
                        <Button variant="outline-primary" onClick={this.handleFeedbackSubmit} disabled={this.state.submitDisabled}>
                            Submit
                        </Button>
                    </div>
                </div>
            )
        }
    }
}
